import { getSurveyLocationResetExceptionRules } from 'containers/SurveyPage/constants';
import messages from './messages';

const scope = 'app/AISurveyBuilder';

const FETCH_AI_HISTORY = `${scope}/FETCH_AI_HISTORY`;
const FETCH_AI_HISTORY_SUCCESS = `${scope}/FETCH_AI_HISTORY_SUCCESS`;
const FETCH_AI_HISTORY_ERROR = `${scope}/FETCH_AI_HISTORY_ERROR`;
const ADD_AI_MESSAGE = `${scope}/ADD_AI_MESSAGE`;
const UPDATE_AI_MESSAGE = `${scope}/UPDATE_AI_MESSAGE`;
const SET_AI_PANEL = `${scope}/SET_AI_PANEL`;
const SET_AI_WEB_WORKER = `${scope}/SET_AI_WEB_WORKER`;
const SET_AI_STATUS = `${scope}/SET_AI_STATUS`;
const START_STREAMING_AI_MESSAGE = `${scope}/START_STREAMING_AI_MESSAGE`;
const SET_STREAMING_AI_MESSAGE = `${scope}/SET_STREAMING_AI_MESSAGE`;
const UPDATE_STREAMING_AI_MESSAGE_CONTENT = `${scope}/UPDATE_STREAMING_AI_MESSAGE_CONTENT`;
const SET_ERROR_STREAMING_AI_MESSAGE = `${scope}/SET_ERROR_STREAMING_AI_MESSAGE`;
const RESET_STREAMING_AI_MESSAGE = `${scope}/RESET_STREAMING_AI_MESSAGE`;
const SET_AI_USER_PROMPT = `${scope}/SET_AI_USER_PROMPT`;
const SET_AI_USER_PROMPT_WITH_OPTIONS = `${scope}/SET_AI_USER_PROMPT_WITH_OPTIONS`;
const CLEAR_STREAMING_MESSAGE_CONTENT = `${scope}/CLEAR_STREAMING_MESSAGE_CONTENT`;
const GIVE_POSITIVE_FEEDBACK = `${scope}/GIVE_POSITIVE_FEEDBACK`;
const GIVE_NEGATIVE_FEEDBACK = `${scope}/GIVE_NEGATIVE_FEEDBACK`;
const GIVE_UNDO_FEEDBACK = `${scope}/GIVE_UNDO_FEEDBACK`;

const AI_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  STREAMING: 'streaming',
  ERROR: 'error',
};

export const AI_POLLFISH_MESSAGE_TYPES = {
  ERROR: 'error',
  MESSAGE: 'message',
  QUESTIONNAIRE: 'questionnaire',
  RETRY: 'retry',
  FEEDBACK: 'feedback',
};

export const chatMessageTypes = {
  HUMAN: 'human',
  AI: 'ai',
  ERROR: 'error',
  ACTION: 'action',
};

export {
  FETCH_AI_HISTORY,
  FETCH_AI_HISTORY_SUCCESS,
  FETCH_AI_HISTORY_ERROR,
  ADD_AI_MESSAGE,
  UPDATE_AI_MESSAGE,
  SET_AI_PANEL,
  AI_STATES,
  SET_AI_WEB_WORKER,
  SET_AI_STATUS,
  START_STREAMING_AI_MESSAGE,
  SET_STREAMING_AI_MESSAGE,
  UPDATE_STREAMING_AI_MESSAGE_CONTENT,
  CLEAR_STREAMING_MESSAGE_CONTENT,
  SET_ERROR_STREAMING_AI_MESSAGE,
  RESET_STREAMING_AI_MESSAGE,
  SET_AI_USER_PROMPT,
  SET_AI_USER_PROMPT_WITH_OPTIONS,
  GIVE_POSITIVE_FEEDBACK,
  GIVE_NEGATIVE_FEEDBACK,
  GIVE_UNDO_FEEDBACK,
};

export const locationResetExceptionRoutes = [
  ...getSurveyLocationResetExceptionRules(),
];

export const positiveFeedbackMessages = [
  messages.feedbackResponses.positiveFeedback1,
  messages.feedbackResponses.positiveFeedback2,
  messages.feedbackResponses.positiveFeedback3,
  messages.feedbackResponses.positiveFeedback4,
  messages.feedbackResponses.positiveFeedback5,
];

export const negativeFeedbackOptions = [
  {
    labelMessage: messages.feedbackResponses.negativeFeedbackUserOption1,
    value: 1,
  },
  {
    labelMessage: messages.feedbackResponses.negativeFeedbackUserOption2,
    value: 2,
  },
  {
    labelMessage: messages.feedbackResponses.negativeFeedbackUserOption3,
    value: 3,
  },
  {
    labelMessage: messages.feedbackResponses.negativeFeedbackUserOptionOther,
    value: 10,
    manualValue: true,
    placeholder:
      messages.feedbackResponses.negativeFeedbackUserOptionOtherPlaceholder,
  },
];
